import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import {
  FaLightbulb,
  FaUsers,
  FaStar,
  FaShieldAlt,
} from 'react-icons/fa';
import Header from '../header/header';
import Footer from '../commun/Footer';

import './About.css';

const About = () => {


  return (
    <Box className="about">
      <Header />

      {/* Hero image avec texte superposé */}
      <Box className="hero-image-wrapper">
        <picture>
          <source media="(max-width: 768px)" srcSet="/images/about/hero-mobile.webp" />
          <source media="(max-width: 1280px)" srcSet="/images/about/hero-tablet.webp" />
          <img
            src="/images/about/hero-desktop.webp"
            alt="Illustration Cooptaleo"
            className="hero-img"
          />
        </picture>
        <Box className="hero-overlay">
          <Container maxWidth="lg">
            <Box className="hero-content-about">
              <Typography variant="h3" className="hero-title">
                À propos de Cooptaleo
              </Typography>
              <Typography variant="h6" className="hero-subtitle">
                Une plateforme née de la collaboration, portée par l’IA, dédiée au recrutement IT.
              </Typography>
            </Box>
          </Container>
        </Box>
      </Box>

      {/* Section Notre Histoire */}
      <Box className="section-spacing-large">
        <Container maxWidth="md">
          <Typography variant="h4" align="center" gutterBottom className="titles">
            Qui nous sommes
          </Typography>
          <Typography variant="body1" align="center" className="about-intro-text">
            <strong>
              Cooptaleo est née d’un constat terrain : le recrutement IT est trop souvent complexe et chronophage.
            </strong>
          </Typography>
          <Typography variant="body1" align="center" className="about-intro-text">
            Nous avons imaginé une plateforme unique, capable de fédérer entreprises, recruteurs indépendants et experts IT autour d’une même dynamique. Notre force : allier la puissance de l’intelligence artificielle à une approche profondément humaine, pour remettre la fluidité, la transparence et la performance au cœur du recrutement.
          </Typography>
        </Container>
      </Box>

      {/* Mission & Vision */}
      <Box className="mission-vision-section">
        <Container>
          <Typography variant="h4" align="center" gutterBottom className="titles">
            Ce que nous apportons
          </Typography>
          <Box className="values-grid-container">
            {[
              {
                icon: <FaShieldAlt className="benefit-icon" />,
                title: 'Une technologie au service de vos recrutements.',
                desc: 'Chez Cooptaleo, nous structurons chaque étape, automatisons les tâches à faible valeur ajoutée, et optimisons les correspondances grâce à une IA experte du marché IT.',
              },
              {
                icon: <FaLightbulb className="benefit-icon" />,
                title: 'Une expertise au service de vos ambitions',
                desc: 'Notre mission : faire gagner du temps aux entreprises, offrir de vraies opportunités aux recruteurs, et donner plus de visibilité aux talents.',
              },
            ].map((value, index) => (
              <Card className="value-card" key={index}>
                <CardContent>
                  {value.icon}
                  <Typography variant="h6" align="center" className="value-title-text">
                    {value.title}
                  </Typography>
                  <Typography variant="body2" align="center" className="value-desc-text">
                    {value.desc}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>

      {/* Nos engagements */}
      <Box className="values-section">
        <Container>
          <Typography variant="h4" align="center" gutterBottom className="titles">
            Nos engagements
          </Typography>
          <Typography variant="body1" align="center" className="about-intro">
            Cooptaleo place la transparence, la sécurité et l'efficacité au cœur de sa plateforme.
          </Typography>

          <Box className="values-grid-container">
            {[
              {
                icon: <FaUsers className="value-icon" />,
                title: 'Transparence totale',
                desc: 'Chaque action est tracée et chaque échange est visible. Vous gardez le contrôle à tout moment.',
              },
              {
                icon: <FaStar className="value-icon" />,
                title: 'Pertinence avant tout',
                desc: 'Chaque mise en relation repose sur une analyse fine des besoins, des profils et des contextes.',
              },
              {
                icon: <FaShieldAlt className="value-icon" />,
                title: 'Sécurité renforcée',
                desc: 'Vos données sont hébergées en Europe, dans le respect strict du RGPD.',
              },
              {
                icon: <FaLightbulb className="value-icon" />,
                title: 'Innovation utile',
                desc: 'Notre IA vous fait gagner en temps, en précision et en efficacité à chaque étape.',
              },
            ].map((value, index) => (
              <Card className="value-card" key={index}>
                <CardContent>
                  <Box className="circle-icon-large">{value.icon}</Box>
                  <Typography variant="h6" align="center" className="value-title-text">
                    {value.title}
                  </Typography>
                  <Typography variant="body2" align="center" className="value-desc-text">
                    {value.desc}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>

      {/* Call to Action */}
      <Box className="why-section">
        <Container maxWidth="md" style={{ textAlign: 'center' }} className="titles">
          <Typography variant="h4" gutterBottom>
            Prêt à transformer vos recrutements ?
          </Typography>
          <Typography variant="body1" className="cta-subtitle">
            Découvrez comment Cooptaleo peut vous aider à recruter mieux, plus vite, et plus simplement.
          </Typography>
          <Box mt={3}>
            <Button variant="contained" color="primary" size="large" href="signup">
              Créer un compte gratuitement
            </Button>
          </Box>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};

export default About;
